// One-click upgrade links (Oct 2026). `/app?upgrade=monthly|annual|maximizer` takes a logged-in
// user straight to Stripe Checkout; a logged-out user signs in first and is then sent on to
// checkout (the intent survives the login round-trip in localStorage, incl. Google/Apple redirects).
// Every upgrade email and the personal outreach link here. Before this, every "upgrade" email
// pointed at /#pricing, which bounces logged-in users to a dashboard with no pay button.
import { logPublicEvent } from './publicEvent';

const KEY = 'rigacap_pending_upgrade';
const MAX_AGE_MS = 30 * 60 * 1000;
const PLANS = { monthly: { plan: 'monthly', maximizer: false },
                annual: { plan: 'annual', maximizer: false },
                maximizer: { plan: 'monthly', maximizer: true } };

// Read ?upgrade= from the URL, persist it, strip it from the address bar. Returns the intent or null.
export function captureUpgradeIntent() {
  try {
    const p = new URLSearchParams(window.location.search);
    const v = (p.get('upgrade') || '').toLowerCase();
    if (!PLANS[v]) return null;
    const intent = { ...PLANS[v], key: v, utm_source: p.get('utm_source'), utm_campaign: p.get('utm_campaign'), at: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(intent));
    p.delete('upgrade');
    const qs = p.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
    return intent;
  } catch { return null; }
}

// Consume a stored intent (one-shot; expires after 30 min so it can never fire a surprise checkout).
export function takeUpgradeIntent() {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const intent = JSON.parse(raw);
    return intent && Date.now() - (intent.at || 0) < MAX_AGE_MS ? intent : null;
  } catch { return null; }
}

// Start Stripe Checkout. Logs the first-party `checkout_redirect` funnel event (dead since Aug 24)
// so checkout starts are measurable again without depending on cookie consent.
export async function startCheckout(api, { plan = 'monthly', maximizer = false, source = 'app', utm_source, utm_campaign } = {}) {
  logPublicEvent('checkout_redirect', { path: '/app', utm_source: utm_source || source, utm_campaign: utm_campaign || plan });
  const value = (plan === 'annual' ? 1099 : 59) + (maximizer ? 79 : 0);
  if (window.gtag) window.gtag('event', 'begin_checkout', { value, currency: 'USD' });
  const d = await api.post('/api/billing/create-checkout', { plan, maximizer });
  window.location.href = d.checkout_url;
}
